import { Component } from "@angular/core";

@Component({
  templateUrl: "./yes-no-dialog.component.html",
})
export class YesNoDialogComponent {
  title = "Are you sure?";
  content = "";
}
